import { render, staticRenderFns } from "./advisor-advert.vue?vue&type=template&id=8410dc52&"
import script from "./advisor-advert.vue?vue&type=script&lang=js&"
export * from "./advisor-advert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports